/* eslint-disable max-len */
export const DiscountDetails = { url: "/okazje/%7BbrandSeoName%7D/%7BdiscountSeoName%7D", type: undefined as { brandSeoName: string | number; discountSeoName: string | number; } };
export const SharedDiscount = "/Discount/SharedDiscount";
export const Discount = { url: "/api/discount/%7Baction%7D", type: undefined as { action: string | number; } };
